import saveFile from "file-saver";
import { getExportDataExcelHistoryDocument } from "api/ux/src";
import { b64toBlob } from "common/file-helpers";
import { language } from "language/default";
const withOptions = (queryConfig) => {
    queryConfig.force = true;
    queryConfig.options = queryConfig.options || {};
    queryConfig.meta = { ...{ errorMessage: language.en.grid.excelExport.downloadExcelFailed,
            pendingMessage: language.en.grid.excelExport.downloadExcelPending,
            successMessage: language.en.grid.excelExport.downloadExcelSucceeded } };
    return queryConfig;
};
export const getGetExportDataExcelHistoryDocument = (exportId) => {
    const requestQueryConfig = getExportDataExcelHistoryDocument({ id: exportId }, {
        transform: (response) => {
            if (response.content) {
                const blob = b64toBlob(response?.content, response.contentType);
                if (blob.size > 0) {
                    saveFile(blob, response.fileName);
                }
            }
            return {};
        }
    });
    withOptions(requestQueryConfig);
    return requestQueryConfig;
};
